'use client';

import { sendGTMEvent } from '@/fo/api/gtm';

import type { CookieConsentGroups } from '../types';

import {
  COOKIE_CONSENT_DISMISS_NAME,
  COOKIE_CONSENT_NAME,
  COOKIE_GROUPS,
  DEFAULT_COOKIE_GROUPS,
  parseCookieConsentValue,
  toActiveGroups
} from './cookieConsent';

/** Прячет попап до конца сессии браузера, согласие не пишет */
export const dismissCookieConsentForSession = () => {
  document.cookie = `${COOKIE_CONSENT_DISMISS_NAME}=1; Path=/; SameSite=Lax`;
};

/** Читает значение cookie согласия на клиенте */
const getCookieConsentClient = (): string | null => {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${COOKIE_CONSENT_NAME}=`));

  return match ? decodeURIComponent(match.split('=')[1]) : null;
};

/** Отправляет CookieChecker с актуальными группами, учитывая bypass */
export const pushCookieChecker = (bypass = false) => {
  if (bypass) {
    sendGTMEvent({
      event: 'CookieChecker',
      ActiveGroups: toActiveGroups(DEFAULT_COOKIE_GROUPS)
    });
    return;
  }

  const consent = parseCookieConsentValue(getCookieConsentClient());
  if (!consent) return;

  sendGTMEvent({
    event: 'CookieChecker',
    ActiveGroups: toActiveGroups(consent)
  });
};

/** Все опциональные группы включены */
export const isFullCookieConsent = (groups: CookieConsentGroups) =>
  groups.analytical && groups.functional && groups.marketing;

/** Принять все / сохранить при всех включённых свитчерах */
export const pushCookieConsentChoice = (groups: CookieConsentGroups) => {
  const activeGroups = toActiveGroups(groups);

  sendGTMEvent({ event: 'CookieChecker', ActiveGroups: activeGroups });

  if (activeGroups !== COOKIE_GROUPS.necessary.id) {
    sendGTMEvent({ event: 'cookieConsent' });
  }
};

/** Сохранили настройки, часть групп выключена. ActiveGroups — оставшиеся */
export const pushCookieChange = (groups: CookieConsentGroups) => {
  sendGTMEvent({
    event: 'cookieChange',
    ActiveGroups: toActiveGroups(groups)
  });
};

/** Открыли настройки */
export const pushPopupSettings = () => {
  sendGTMEvent({ event: 'popupSettings' });
};

/** Закрыли попап крестиком: согласие не пишем, все группы остаются активны */
export const pushPopupClosed = () => {
  sendGTMEvent({
    event: 'popupClosed',
    ActiveGroups: toActiveGroups(DEFAULT_COOKIE_GROUPS)
  });
};
